var _defs, _path, _use, _use2, _path2, _use3, _use4, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1823,
    height: 2500,
    viewBox: "0 0 256 351",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.253 280.732l1.605-3.131 99.353-188.518-44.15-83.475C54.392-1.283 45.074.474 43.87 8.188L1.253 280.732z",
    id: "a"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.417 148.974l32.039-32.812-32.039-61.007c-3.042-5.791-10.433-6.398-13.443-.59l-17.705 34.109-.53 1.744 31.678 58.556z",
    id: "c"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -9,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0",
    in: "shadowInnerInner1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 282.998l2.123-2.972L102.527 89.512l.212-2.017L58.48 4.358C54.77-2.606 44.33-.845 43.114 6.951L0 282.998z",
    fill: "#FFC24A"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFA712",
    fillRule: "evenodd",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    filter: "url(#b)",
    xlinkHref: "#a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.005 150.38l32.955-33.75-32.965-62.93c-3.129-5.957-11.866-5.975-14.962 0L102.42 87.287v2.86l32.584 60.233z",
    fill: "#F4BD62"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "#FFA50E",
    fillRule: "evenodd",
    xlinkHref: "#c"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    filter: "url(#d)",
    xlinkHref: "#c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6820C",
    d: "M0 282.998l.962-.968 3.496-1.42 128.477-128 1.628-4.431-32.05-61.074z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.121 347.551l116.275-64.847-33.204-204.495c-1.039-6.398-8.888-8.927-13.468-4.34L0 282.998l115.608 64.548a24.126 24.126 0 0 0 23.513.005",
    fill: "#FDE068"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.354 282.16L221.402 79.218c-1.03-6.35-7.558-8.977-12.103-4.424L1.29 282.6l114.339 63.908a23.943 23.943 0 0 0 23.334.006l115.392-64.355z",
    fill: "#FCCA3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.12 345.64a24.126 24.126 0 0 1-23.512-.005L.931 282.015l-.93.983 115.607 64.548a24.126 24.126 0 0 0 23.513.005l116.275-64.847-.285-1.752-115.99 64.689z",
    fill: "#EEAB37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase1);
export default __webpack_public_path__ + "static/media/firebase-1.e6583a29712875c8977afcba1d0b6883.svg";
export { ForwardRef as ReactComponent };